export default class LocalizationResourceCache {
    constructor(localizationConfig, xhrGet) {
        this.xhrGet = xhrGet;

        this.resourcePath = localizationConfig.config.resourcePath;

        this.resources = {};
    }

    loadResources(culture) {
        return new Promise((resolve, reject) => {
            var cultureResourcePath = encodeURI(this.resourcePath.replace('{culture}', culture));

            if (this.resources[culture]) {
                resolve(this.resources[culture]);
            } else {
                this.resources[culture] = {};
                this.xhrGet(cultureResourcePath)
                    .then(
                        (result) => {
                            this.resources[culture] = result;
                            resolve(result);
                        },
                        (rejection) => {
                            reject(rejection);
                        }
                    );
            }
        });
    }

    getResource(culture, key) {
        var keyParts = key.split('.'),
            resource = this.resources[culture] ? this.resources[culture] : null;

        if (!resource) {
            return null;
        }

        keyParts.map((keyPart) => {
            if (!resource) {
                return;
            }

            resource = resource[keyPart] ? resource[keyPart] : null;
        });

        return resource;
    }
}



/** WEBPACK FOOTER **
 ** ./src/localization/core/localization-resource-cache.js
 **/